import React from 'react'

import { H2 } from '@frame/ui-primitives/h2'
import { P } from '@frame/ui-primitives/p'

import { LearnMore } from './learn-more-content'

type Props = {
  verifierName: string
  showLearnMore: boolean
}

export function AllTasksVerifiedContent({ verifierName, showLearnMore }: Props) {
  return (
    <>
      <H2 className="mb-3 mt-5 text-center text-moss-700">You're all set</H2>
      <P>Thanks for providing your information. Truework will securely share with {verifierName} shortly.</P>
      {showLearnMore && (
        <P className="mt-3">
          <LearnMore />
        </P>
      )}
    </>
  )
}
